window.onload = function () {
	// const wishlistItems = Solver.wishlist.get();
	// Solver.wishlist.ui(wishlistItems);
};
